import { makeAutoObservable } from "mobx";
import { RMutableMap } from "../../collections/RMutableMap";
import { randomUUID } from "../../id";
import { LockId } from "./LockId";
/**
 * A collection of locks that force a value to be immutable.
 *
 * Contains the information on why the value is locked and a way for the lock to be released.
 */
export class Locks {
    constructor() {
        this.raw = RMutableMap.empty();
        makeAutoObservable(this);
    }
    get locked() {
        return !this.raw.isEmpty;
    }
    get serialized() {
        return this.raw.values.raw.join(", ");
    }
    /**
     * Add a lock
     * @param owner name of the owner
     * @returns a thunk which releases the lock
     */
    addLock(owner) {
        const lockId = new LockId(randomUUID());
        this.raw.set(lockId, owner);
        return () => {
            this.raw.delete(lockId);
        };
    }
}
